import React, {useContext} from 'react';
import { Row, Col } from 'react-bootstrap';
import InviteInvestors from "../invite-investors/invite-investors";
import UploadOrdersList from "../upload-orders-list/upload-orders-list";
import DownloadTermSheetProspectus from "../download-termsheet-prospectus/download-termsheet-prospectus";
import GenerateSalesReport from "../generate-sales-report/generate-sales-report";
import ConsolidateATP from '../consolidate-atp/consolidate-atp';
import styles from './section-actions.module.scss';
import {SecurityContext} from "../../../../../context/security-context";
import {dateBetween, strToDate} from "../../../../../helpr/helper";
import DownloadOrdersList from "../download-orders-list/download-orders-list";
import SubmitOrders from "../submit-orders/submit-orders";
import { ATP_ARCHIVE_NOT_STARTED } from "../../../../../helpr/constants";

const ActionsSection = () => {
  const { securityState } = useContext(SecurityContext);
  const start = strToDate(securityState.offerDate);
  console.log(start);
  const end = strToDate(securityState.offerCloseDate);
  console.log(end);
  const now = new Date()
  now.setHours(0,0,0,0);

  const inviteInvestorStyle = now <= end && securityState.securityStatus === '0'
    ? styles['enabled'] : styles['disabled'];
  const uploadOrdersStyle = now >= start && securityState.securityStatus === '0'
    ? styles['enabled'] : styles['disabled'];
  const generateReportStyle = now >= start && (securityState.securityStatus === '0' || securityState.securityStatus === '2')
    ? styles['enabled'] : styles['disabled'];
  const submitOrdersStyle = now >= start && securityState.securityStatus === '0'
    ? styles['submit-enabled'] : styles['disabled'];
  const consolidatedATPStyle = securityState.archiveStatus === ATP_ARCHIVE_NOT_STARTED
    ? styles['disabled'] : styles['enabled'];

  return (
    <div className={styles['section']}>
      <Row className={styles['row-block']}>
        <Col xs={6} lg={6} className={styles['block']}>
          <div className={`${styles['action']} ${inviteInvestorStyle}`}>
            <InviteInvestors />
          </div>
        </Col>
        <Col xs={6} lg={6} className={styles['block']}>
          <div className={`${styles['action']} ${styles['enabled']}`}>
            <DownloadTermSheetProspectus />
          </div>
        </Col>
      </Row>
      <Row className={styles['row-block']}>
        <Col xs={6} lg={6} className={styles['block']}>
          <div className={`${styles['action']} ${uploadOrdersStyle}`}>
            <UploadOrdersList security={securityState}/>
          </div>
        </Col>
        <Col xs={6} lg={6} className={styles['block']}>
          <div className={`${styles['action']} ${uploadOrdersStyle}`}>
            <DownloadOrdersList />
          </div>
        </Col>
      </Row>
      <Row className={styles['row-block']}>
        <Col xs={6} lg={6} className={styles['block']}>
          <div className={`${styles['action']} ${generateReportStyle}`}>
            <GenerateSalesReport />
          </div>
        </Col>
        <Col xs={6} lg={6} className={styles['block']}>
          <div className={`${styles['action']} ${submitOrdersStyle}`}>
            <SubmitOrders />
          </div>
        </Col>
      </Row>
      <Row className={styles['row-block']}>
        <Col xs={6} lg={6} className={styles['block']}>
          <div className={`${styles['action']} ${consolidatedATPStyle}`}>
            <ConsolidateATP />
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default ActionsSection;
